import React from "react";
import Lottie from "lottie-react";
import ecgAnimation from "../assets/animation/ecg-animation2.json";

interface LoadingAnimationProps {
  show: boolean;
  onComplete: () => void;
}

const LoadingAnimation: React.FC<LoadingAnimationProps> = ({
  show,
  onComplete,
}) => {
  if (!show) return null;

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-60 z-30">
      <div className="flex items-center justify-center w-1/2 h-1/2 max-w-xs md:max-w-md lg:max-w-md">
        <Lottie
          animationData={ecgAnimation}
          loop={false}
          onComplete={onComplete}
          className="w-full h-full"
        />
      </div>
    </div>
  );
};

export default LoadingAnimation;
